






















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import CargoDescription from '@/components/inquiry/new/CargoDescription.vue';
import {
  InquiryInput,
  CargoDescriptionInput,
  InquiryFields,
  CargoTypeEnum,
  TransportationTypeEnum
} from '@/types/graphql/schemaTypes';
import CargoList from '../new/CargoList.vue';

@Component({
  components: {
    CargoDescription
  }
})

export default class UpsertCargo extends Vue {
  @Prop({ default: () => ({ cargoDescription: {} }) }) inquiry!: InquiryFields;
  @Prop({ default: false }) readOnly!: boolean;
  @Prop({
    default: TransportationTypeEnum.any,
    required: true,
    type: String
  }) transportationType!: TransportationTypeEnum;

  @Prop() stepNumber?: number;

  public inquiryInput: InquiryInput = { cargoType: this.inquiry.cargoType || CargoTypeEnum.LCL };

  @Watch('transportationType')
  public transportationTypeUpdated() {
    if (this.inquiry.transportationType === this.transportationType) {
      this.inquiryInput.cargoType = this.inquiry.cargoType || CargoTypeEnum.LCL;
    } else if (this.transportationType !== TransportationTypeEnum.sea) {
      this.inquiryInput.cargoType = CargoTypeEnum.LCL;
    }
  }

  public updateCargoType(cargoType: CargoTypeEnum) {
    this.inquiryInput.cargoType = cargoType;
  }

  public updateCargoDescription(cargoDescription: CargoDescriptionInput) {
    this.inquiryInput.cargoDescription = cargoDescription;
    this.$emit('cargoUpdated', this.inquiryInput);
  }
}
